import { create } from 'apisauce';
import { getQueryString } from '../functions';
import { getCookies } from '../store/useCookies';
import { env } from '../utils/env/config';
export const ip = 'http://192.168.1.169:2000';

export const MODE_API = {
  DEVELOPMENT: env.url_dev,
  UAT: env.url_uat,
  PRODUCTION: env.url_prd,
};
// export const CONNECT_API = 'https://jsonplaceholder.typicode.com';
export const CONNECT_API = MODE_API[`${env.node_env}`.toUpperCase()];
const api = create({
  baseURL: CONNECT_API,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 seconds
});

const apiupload = create({
  baseURL: CONNECT_API,
  withCredentials: true,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
/**
 * ฟังก์ชั่นสำหรับ ยิงข้อมูล
 * @param {string} path
 * @param {{}} obj
 * @return {{}}
 */
export const POST = (path, obj, token = getCookies('accessToken')) =>
  new Promise((resolve, reject) => {
    api
      .post(path, obj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.ok) {
          resolve(response.data);
        } else {
          response.data
            ? reject(response.data)
            : reject({ success: false, message: response.problem });
        }
      })
      .catch((err) => reject(err));
  });

/**
 * ฟังก์ชั่นสำหรับ ยิงข้อมูล
 * @param {string} path
 * @param {{}} obj
 * @return {{}}
 */
export const PUT = (path, obj, token = getCookies('accessToken')) =>
  new Promise((resolve, reject) => {
    api
      .put(path, obj, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
      .then((response) => {
        if (response.ok) {
          resolve(response.data);
        } else {
          response.data
            ? reject(response.data)
            : reject({ success: false, message: response.problem });
        }
      })
      .catch((err) => reject(err));
  });

/**
 * ฟังก์ชั่นสำหรับ ดึงข้อมูล
 * @param {string} path
 *
 */
export const GET = (path, token = getCookies('accessToken')) =>
  new Promise((resolve, reject) => {
    api
      .get(
        path,
        {},
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        },
      )
      .then((response) => {
        if (response.ok) {
          resolve(response.data);
        } else {
          response.data
            ? reject(response.data)
            : reject({ success: false, message: response.problem });
        }
      })
      .catch((err) => reject(err));
  });

export const UPLOAD = (path, formdata, token = getCookies('accessToken')) =>
  new Promise((resolve, reject) => {
    apiupload
      .post(path, formdata, {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
      .then((response) => {
        if (response.ok) {
          resolve(response.data);
        } else {
          response.data
            ? reject(response.data)
            : reject({ success: false, message: response.problem });
        }
      })
      .catch((err) => reject(err));
  });

/* ################################################## URL ################################################## */
export const LOGIN = `/authen/login`;
export const LOGIN_GOOGLE = `/authen/login-google`;
export const REGISTER = `/authen/register`;
export const GET_PROFILE = `/authen/get_profile`;
export const GET_ALL_PRODUCT = `/product/get-all`;
export const GET_PRODUCT_SEARCH = (obj) => `/product/search?${getQueryString(obj)}`;

export const GET_ALL_POST = `/posts`;
export const INSERT_POST = `/posts`;
export const UPDATE_POST = (id) => `/posts/${id}`;
export const GET_POST_BY_ID = (id) => `/posts/${id}`;

//initiate user
export const GET_CUSTOMER_LINE = (userId) =>
  `/warranty/focus/api/v2/line-customer/customers/lineuid/${userId}`;

// register telephone
export const POST_REQUEST_OTP = `/warranty/focus/api/v2/line-customer/otp/call`;
export const POST_CONFIRM_OTP = `/warranty/focus/api/v2/line-customer/otp/verify`;
export const GET_POLICIES_PDPA = `/warranty/focus/api/v2/line-customer/options/policies/pdpa`;

// home
export const GET_ITEMS = (userId) => `/warranty/focus/api/v2/line-customer/items/${userId}`;

//warranty
export const GET_VERIFY_NUMBER = (warrantyNumberCode) =>
  `/warranty/focus/api/v2/line-customer/serial-number/verify/${warrantyNumberCode}`;
export const POST_REGISTER_INFO = () => `/warranty/focus/api/v2/line-customer/warranties/add`;
//option
export const GET_CHANNEL_BUY = () => `/warranty/focus/api/v2/line-customer/options/channel-buys`;

//claims
export const POST_CLAIM_WARRANTY_VERIT = `/warranty/focus/api/v2/line-customer/claims/warranty/verify`;
export const POST_CLAIM_INSERT = `/warranty/focus/api/v2/line-customer/claims/insert`;
export const POST_CLAIM_UPDATE_BOOKING = `/warranty/focus/api/v2/line-customer/claims/update-booking-date`;

export const GET_OPTION_ADDRESSES_BY_ZIPCODE = (id) =>
  `/warranty/focus/api/v2/line-customer/options/addresses/zipcode/${id}`;
export const GET_POLICIES = () =>
  `/warranty/focus/api/v2/line-customer/options/policies/warranty/agreement`;
export const GET_REASON_CHANGE_BOOKING_DATE = () =>
  `/warranty/focus/api/v2/line-customer/options/claim-booking`;
